import { extend } from '@thd-nucleus/data-sources';

import { CardCallToActionDataModel } from './CardCallToActionDataModel';
import { PodCallToActionDataModel } from './PodCallToActionDataModel';

export const CallToActionDataModel = extend(
  CardCallToActionDataModel,
  PodCallToActionDataModel,
);
